module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMoyKz4TwlmGDVg1IBRA4aLAQDsb1Af2eExDwAAAABJRU5ErkJggg=="